import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import en from './locales/en.json';

const STORAGE_KEY = 'cantonabo_language';

export const SUPPORTED_LANGUAGES = ['es', 'en'] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/**
 * react-snap (prerender SEO) navega con userAgent "ReactSnap". En ese caso el
 * idioma debe ser determinista (es = mercado principal) e ignorar el
 * localStorage que arrastra de la pagina anterior; las rutas `/en/*` fijan
 * su idioma via `useRouteLanguage`.
 */
function isPrerender(): boolean {
  return typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent);
}

function getInitialLanguage(): AppLanguage {
  if (isPrerender()) {
    return 'es';
  }
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'es' || stored === 'en') {
    return stored;
  }
  const browserLang = navigator.language.toLowerCase();
  return browserLang.startsWith('en') ? 'en' : 'es';
}

export function setAppLanguage(lang: AppLanguage): void {
  localStorage.setItem(STORAGE_KEY, lang);
  document.documentElement.lang = lang;
  void i18n.changeLanguage(lang);
}

const initialLanguage = getInitialLanguage();
document.documentElement.lang = initialLanguage;

void i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
  },
  lng: initialLanguage,
  fallbackLng: 'es',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
